var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0816001 3.8525L10.7316 14.9475C11.0467 15.2759 11.4675 15.4709 11.9126 15.4947C12.3578 15.5185 12.7955 15.3694 13.1412 15.0763L13.278 14.9475L23.9208 3.86C23.9552 3.9975 23.9784 4.13792 23.9904 4.28125L24 4.5V19.5C24.0002 20.1307 23.7715 20.7382 23.3598 21.2007C22.9481 21.6632 22.3838 21.9464 21.78 21.9938L21.6 22H2.4C1.79451 22.0002 1.21132 21.762 0.767342 21.3331C0.323365 20.9043 0.051412 20.3164 0.00600014 19.6875L0 19.5V4.5C0 4.35 0.012 4.20417 0.036 4.0625L0.0816001 3.8525ZM21.6 2C21.7456 2 21.8876 2.01292 22.026 2.03875L22.23 2.0875L12.006 12.7375L1.7784 2.085C1.9112 2.0475 2.0472 2.0225 2.1864 2.01L2.4 2H21.6Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMail);
export default __webpack_public_path__ + "static/media/ic_mail.fcc16c7ec52f8bbd2ae9fe0fdd5b6c3d.svg";
export { ForwardRef as ReactComponent };